import React, { useEffect, useState } from "react";
import "./conclave css files/navbarconclave.css";
import { Link } from "react-router-dom";
import { MdMenu } from "react-icons/md";
import { AiOutlineUser } from "react-icons/ai";
import CustDialogBox from "../../components/custom dialogbox/CustDialogBox";
import ContactUs from "../../pages/home/dialog box/ContactUs";
import AlertCustDialogBox from "../../components/alertbox/AlertCustDialogBox";
import Alertbox from "../../components/alertbox/Alertbox";

const dwec_logo_conclave = require("../../assets/dwec_logo.png");

function NavbarConclave(props) {
  const [toggleModal, setToggleModal] = useState(false);
  const [alertToggleModal, setAlertToggleModal] = useState(false);

  function handleContactClick(toggleValue) {
    setToggleModal(toggleValue);
  }

  function hanldeContactPopUp(toggleValue) {
    setAlertToggleModal(toggleValue);
    setTimeout(() => {
      setAlertToggleModal(false);
    }, 2000);
  }
  return (
    <div>
      <nav className="navbar_conclave_main_container">
        <a href="#conclave" className="conclave_logo">
          <img src={dwec_logo_conclave} alt="dwec_logo" />
        </a>

        <input type="checkbox" id="toggler_conclave" />

        <label htmlFor="toggler_conclave">
          <MdMenu className="md_menu" />
        </label>

        <div className="conclave_nav_container">
          <ul className="list_conclave_container">
          <li>
              <a href="/">HOME</a>
            </li>
            <li>
              <a href="/Conclave#speaker">SPEAKERS</a>
            </li>
            <li>
            <a href="/AgendaPage#Agenda">AGENDA OF THE CONCLAVE</a>
            </li>
            <li>
              <a href="/Conclave#attendees">ATTENDEES</a>
            </li>

            <button
              className="contact_us_btn_conclave"
              onClick={handleContactClick}
            >
              <AiOutlineUser /> CONTACT US
            </button>
          </ul>
        </div>
      </nav>
      <CustDialogBox
        dialogHeaderName="For any business enquiries"
        open={toggleModal}
        onClose={() => {
          setToggleModal(false);
        }}
      >
        <ContactUs
          hanldeContactPopUp={hanldeContactPopUp}
          handleContactClick={handleContactClick}
        />
      </CustDialogBox>

      <AlertCustDialogBox
        dialogHeaderName=""
        open={alertToggleModal}
        onClose={() => {
          setAlertToggleModal(false);
        }}
      >
        <Alertbox />
      </AlertCustDialogBox>
    </div>
  );
}

export default NavbarConclave;
